module.exports = __webpack_public_path__ + "4b84b7358295daa1199598ef20792f26.jpg";